import { FileText } from 'lucide-react'

export default function ActionInvoice(props) {

    const { text, onClick } = props

    return (
        <>
            <FileText size={16} className='action_btn text-danger me-3'
                onClick={onClick}
                data-tooltip-id='global-tooltip'
                data-tooltip-content={text}
                data-tooltip-place="bottom"
                data-tooltip-class-name='bg-danger tooltip_msg'
            />
        </>
    )
}